import {
    GET_PRIZEPOOL_REQUEST,
    GET_PRIZEPOOL_REQUEST_SUCCESS,
    GET_PRIZEPOOL_REQUEST_FAILURE,
    GET_PRIZEPOOL_DETAIL_REQUEST,
    GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS,
    GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE,
    UPDATE_PRIZEPOOL_DETAIL,
    UPDATE_PRIZEPOOL_DETAIL_SUCCESS,
    UPDATE_PRIZEPOOL_DETAIL_FAILURE,
    GET_LUCKYDRAW_CONFIG,
    GET_LUCKYDRAW_CONFIG_SUCCESS,
    GET_LUCKYDRAW_CONFIG_FAILURE,
    GET_LUCKYDRAW_POOLS,
    GET_LUCKYDRAW_POOLS_SUCCESS,
    GET_LUCKYDRAW_POOLS_FAILURE,
    GET_LUCKYDRAW_WINNERS,
    GET_LUCKYDRAW_WINNERS_SUCCESS,
    GET_LUCKYDRAW_WINNERS_FAILURE,
    UPDATE_LUCKYDRAW_CONFIG,
    UPDATE_LUCKYDRAW_CONFIG_SUCCESS,
    UPDATE_LUCKYDRAW_CONFIG_FAILURE,
    UPDATE_LUCKYDRAW_WINNERS,
    UPDATE_LUCKYDRAW_WINNERS_SUCCESS,
    UPDATE_LUCKYDRAW_WINNERS_FAILURE,
    GET_LUCKYDRAW_POOLS_DETAILS,
    GET_LUCKYDRAW_POOLS_DETAILS_SUCCESS,
    GET_LUCKYDRAW_POOLS_DETAILS_FAILURE
} from "../constants";

export default class PrizePoolAction {
    static GetPrizePool() {
        return {
            type: GET_PRIZEPOOL_REQUEST,
        };
    }
    static GetPrizePool_Success(payload) {
        return {
            type: GET_PRIZEPOOL_REQUEST_SUCCESS,
            payload,
        };
    }
    static GetPrizePool_Failure(payload) {
        return {
            type: GET_PRIZEPOOL_REQUEST_FAILURE,
            payload,
        };
    }

    static GetPrizePool_Detail(id, cb) {
        return {
            type: GET_PRIZEPOOL_DETAIL_REQUEST,
            id,
            cb
        };
    }
    static GetPrizePool_Detail_Success(payload) {
        return {
            type: GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS,
            payload,
        };
    }
    static GetPrizePool_Detail_Failure(payload) {
        return {
            type: GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE,
            payload,
        };
    }

    static UpdatePrizePool_Detail(payload, cb) {
        
        return {
            type: UPDATE_PRIZEPOOL_DETAIL,
            payload,
            cb
        };
    }
    static UpdatePrizePool_Detail_Success(payload) {
        return {
            type: UPDATE_PRIZEPOOL_DETAIL_SUCCESS,
            payload,
        };
    }
    static UpdatePrizePool_Detail_Failure(payload) {
        return {
            type: UPDATE_PRIZEPOOL_DETAIL_FAILURE,
            payload,
        };
    }

    static GetLuckydrawConfig() {
        return {
            type: GET_LUCKYDRAW_CONFIG,
        };
    }
    static GetLuckydrawConfig_Success(payload) {
        return {
            type: GET_LUCKYDRAW_CONFIG_SUCCESS,
            payload,
        };
    }
    static GetLuckydrawConfig_Failure(payload) {
        return {
            type: GET_LUCKYDRAW_CONFIG_FAILURE,
            payload,
        };
    }

    static UpdateLuckydrawConfig_Detail(payload, cb) {
        
        return {
            type: UPDATE_LUCKYDRAW_CONFIG,
            payload,
            cb
        };
    }
    static UpdateLuckydrawConfig_Detail_Success(payload) {
        return {
            type: UPDATE_LUCKYDRAW_CONFIG_SUCCESS,
            payload,
        };
    }
    static UpdateLuckydrawConfig_Detail_Failure(payload) {
        return {
            type: UPDATE_LUCKYDRAW_CONFIG_FAILURE,
            payload,
        };
    }

    static GetLuckydrawPools(payload) {
        return {
            type: GET_LUCKYDRAW_POOLS,
            payload
        };
    }
    static GetLuckydrawPools_Success(payload) {
        return {
            type: GET_LUCKYDRAW_POOLS_SUCCESS,
            payload,
        };
    }
    static GetLuckydrawPools_Failure(payload) {
        return {
            type: GET_LUCKYDRAW_POOLS_FAILURE,
            payload,
        };
    }

    static GetLuckydrawPoolsDetail(payload) {
        return {
            type: GET_LUCKYDRAW_POOLS_DETAILS,
            payload
        };
    }
    static GetLuckydrawPoolsDetail_Success(payload) {
        return {
            type: GET_LUCKYDRAW_POOLS_DETAILS_SUCCESS,
            payload,
        };
    }
    static GetLuckydrawPoolsDetail_Failure(payload) {
        return {
            type: GET_LUCKYDRAW_POOLS_DETAILS_FAILURE,
            payload,
        };
    }

    static GetLuckydrawWinners(payload) {
        return {
            type: GET_LUCKYDRAW_WINNERS,
            payload
        };
    }
    static GetLuckydrawWinners_Success(payload) {
        return {
            type: GET_LUCKYDRAW_WINNERS_SUCCESS,
            payload,
        };
    }
    static GetLuckydrawWinners_Failure(payload) {
        return {
            type: GET_LUCKYDRAW_WINNERS_FAILURE,
            payload,
        };
    }

    static UpdateLuckydrawWinners(payload, cb) {
        
        return {
            type: UPDATE_LUCKYDRAW_WINNERS,
            payload,
            cb
        };
    }
    static UpdateLuckydrawWinners_Success(payload) {
        return {
            type: UPDATE_LUCKYDRAW_WINNERS_SUCCESS,
            payload,
        };
    }
    static UpdateLuckydrawWinners_Failure(payload) {
        return {
            type: UPDATE_LUCKYDRAW_WINNERS_FAILURE,
            payload,
        };
    }

}
